import React from "react";
import { Button } from "@chakra-ui/react";
import {
  CreateAttemptMutationVariables,
  GetUserDocument,
  GetUserQuery,
  useCreateAttemptMutation,
} from "@graphql";
import { navigate } from "gatsby";

type CreateAttemptButtonProps = {
  examSlug: string;
  variables: CreateAttemptMutationVariables;
};

export function CreateAttemptButton({
  variables,
  examSlug,
}: CreateAttemptButtonProps) {
  const [createAttempt, { loading }] = useCreateAttemptMutation({
    variables,
    onCompleted(data) {
      window.gtag?.("event", "exam_start");

      if (data?.user?.attempt) {
        navigate(`/exams/${examSlug}/${data.user.attempt.id}`);
      }
    },
    update(cache, { data }) {
      const cacheData = cache.readQuery<GetUserQuery>({
        query: GetUserDocument,
      });

      if (cacheData) {
        const { me } = cacheData;
        if (me?.__typename === "User" && data?.user?.attempt) {
          cache.writeQuery<GetUserQuery>({
            query: GetUserDocument,
            data: {
              me: {
                ...me,
                attempts: [...(me.attempts ?? []), data.user.attempt],
              },
            },
          });
        }
      }
    },
  });

  return (
    <Button
      colorScheme="indigo"
      onClick={() => createAttempt()}
      isLoading={loading}
    >
      Start exam
    </Button>
  );
}
